class NewsletterPopup extends HTMLElement {
  connectedCallback() {
    this.dialogComponent = this.querySelector('dialog-component');
    this.dialog = this.querySelector('dialog');
    if (!this.dialogComponent || !this.dialog) return;

    this.storageKey = `newsletter-popup-${this.dataset.popupId}`;
    this.isSuccess = this.dataset.success === 'true';
    this.isError = this.dataset.error === 'true';
    this.isDesignMode = this.dataset.designMode === 'true';

    this.dialogComponent.addEventListener('dialog:close', () => this.rememberDismissal());
    if (this.isSuccess || this.isError || this.isDesignMode) {
      this.open();
      return;
    }

    if (this.dataset.subscribed === 'true' || this.wasRecentlyDismissed()) return;

    const delay = Math.max(0, Number(this.dataset.delay) || 0) * 1000;
    this.openTimer = window.setTimeout(() => this.tryOpen(), delay);
  }

  disconnectedCallback() {
    window.clearTimeout(this.openTimer);
  }

  open() {
    this.dialogComponent.showDialog();
  }

  tryOpen() {
    if (this.hasBlockingOverlay()) {
      this.openTimer = window.setTimeout(() => this.tryOpen(), 750);
      return;
    }

    this.open();
  }

  hasBlockingOverlay() {
    const cookieBanner = document.getElementById('shopify-pc__banner');
    const otherDialog = document.querySelector('dialog[open]:not(.newsletter-popup__dialog)');

    return [cookieBanner, otherDialog].some((element) => {
      if (!element || element.hidden) return false;
      const style = window.getComputedStyle(element);
      return style.display !== 'none' && style.visibility !== 'hidden' && element.getClientRects().length > 0;
    });
  }

  rememberDismissal() {
    if (this.isDesignMode || this.isError) return;

    try {
      const days = Math.max(1, Number(this.dataset.dismissDays) || 1);
      localStorage.setItem(this.storageKey, String(Date.now() + days * 86400000));
    } catch (_error) {
      // The popup still works when local storage is blocked.
    }
  }

  wasRecentlyDismissed() {
    try {
      const expiresAt = Number(localStorage.getItem(this.storageKey));
      if (expiresAt > Date.now()) return true;
      localStorage.removeItem(this.storageKey);
    } catch (_error) {
      return false;
    }

    return false;
  }
}

if (!customElements.get('newsletter-popup')) {
  customElements.define('newsletter-popup', NewsletterPopup);
}
